import { Box, Text } from '@factorialco/deprecated-design-system'
import { ProjectionKind, useValidEmployeesDataTable } from 'generated/resources/datatable.graphql'

import DataTable from 'modules/core/components/DataTable'
import i18n from 'modules/core/lib/i18n'

interface Props {
  employeeImportId: number
}

const ValidEmployees = ({ employeeImportId }: Props) => {
  const validEmployees = useValidEmployeesDataTable(
    [
      {
        identifier: 'first_name',
        kind: ProjectionKind.Custom,
        title: i18n.t('payroll_integrations.incidences.datev_lauds.import.table.first_name'),
        template: `{{ importedEmployee.mandatoryData_firstName }}`,
        render: (importedEmployee) => {
          return (
            <Text.Normal size="300" ellipsis>
              {importedEmployee.mandatoryData_firstName}
            </Text.Normal>
          )
        },
      },
      {
        identifier: 'last_name',
        kind: ProjectionKind.Custom,
        title: i18n.t('payroll_integrations.incidences.datev_lauds.import.table.last_name'),
        template: `{{ importedEmployee.mandatoryData_lastName }}`,
        render: (importedEmployee) => {
          return (
            <Text.Normal size="300" ellipsis>
              {importedEmployee.mandatoryData_lastName}
            </Text.Normal>
          )
        },
      },
      {
        identifier: 'email',
        kind: ProjectionKind.Custom,
        title: i18n.t('payroll_integrations.incidences.datev_lauds.import.table.email'),
        template: `{{ importedEmployee.mandatoryData_email }}`,
        render: (importedEmployee) => {
          return (
            <Text.Normal size="300" ellipsis>
              {importedEmployee.mandatoryData_email}
            </Text.Normal>
          )
        },
      },
      {
        identifier: 'datev_employee_code',
        kind: ProjectionKind.Path,
        title: i18n.t(
          'payroll_integrations.incidences.datev_lauds.import.table.datev_employee_code'
        ),
        path: 'mandatoryData_datevEmployeeCode',
      },
      {
        identifier: 'legal_entity_name',
        kind: ProjectionKind.Custom,
        title: i18n.t('payroll_integrations.incidences.datev_lauds.import.table.legal_entity'),
        template: `{{ importedEmployee.mandatoryData_legalEntityName }}`,
        render: (importedEmployee) => {
          return (
            <Text.Normal size="300" ellipsis>
              {importedEmployee.mandatoryData_legalEntityName}
            </Text.Normal>
          )
        },
      },
    ],
    {
      variables: { employeeImportId: employeeImportId, employeeType: 'valid_employees' },
    }
  )

  return (
    <Box
      position="sticky"
      style={{
        bottom: '0',
      }}
      maxHeight="s400"
    >
      <DataTable
        source={validEmployees}
        disableDefaultActions
        pagination={{
          kind: 'offset',
          itemsPerPage: 20,
        }}
      />
    </Box>
  )
}

export default ValidEmployees
